/**
 * O recorte por papel das abas da frente A3, num ponto só, como o legado faz em
 * `travarElementosDoPapel` (`admin.html:3382-3398`).
 *
 * O LEGADO NÃO DECIDE ABA A ABA: ele varre o que foi desenhado e esconde por seletor. Duas regras
 * valem para estas abas, e as duas moram aqui:
 *   1. quem não é administrador não vê `a.excluir-link` nem `a[href="#"]` (`3387-3389`, seletor em
 *      `3375`). O segundo pega também o link "remover" do anexo e o "Abrir" cujo link assinado
 *      falhou (o `href` ficou `#`), e isso é reproduzido, não corrigido;
 *   2. "Apenas Consulta" tem todo campo desabilitado e todo botão que não é de navegação escondido
 *      (`3393-3397`).
 * O RLS continua sendo quem recusa de fato (ADR 0002); isto só não mostra o que ia falhar.
 */

// O papel de quem está logado vem do contexto do painel.
import { usePainel } from '../../../../contexto.js';

/** O que cada aba precisa saber do papel. */
export interface RecortePorPapel {
  // Regra 1: "Excluir" e os links com `href="#"` só existem para o administrador.
  readonly veLinksDeAdministrador: boolean;
  // Regra 2: consulta não edita nem aciona nada.
  readonly somenteLeitura: boolean;
}

/** O recorte do papel atual. Papel desconhecido cai no lado seguro das duas regras. */
export function useRecortePorPapel(): RecortePorPapel {
  const { acesso } = usePainel();
  return {
    // Só o administrador, como o `papelAtual !== 'administrador'` do legado.
    veLinksDeAdministrador: acesso.papel === 'administrador',
    // Só a consulta, como o `papelAtual === 'consulta'` do legado.
    somenteLeitura: acesso.papel === 'consulta',
  };
}
